// extracted by mini-css-extract-plugin
export default {"prescription_invalid__p":"PrescriptionInvalid-styles__prescription_invalid__p__D5V9u","prescription_invalid__link":"PrescriptionInvalid-styles__prescription_invalid__link__h8kai"};